import { Button } from "./Button";
import { SecondaryButton } from "./SecondaryButton";

export function ButtonGroup({
  primaryButtonOnClick,
  primaryButtonText,
  secondaryButtonOnClick,
  secondaryButtonText,
  isLoading,
  primaryTestId,
  secondaryTestId,
}) {
  return (
    <div className="sm:flex sm:flex-row-reverse">
      {primaryButtonOnClick && primaryButtonText && (
        <Button
          onClick={primaryButtonOnClick}
          text={primaryButtonText}
          isLoading={isLoading}
          data-testid={primaryTestId}
        />
      )}

      {secondaryButtonOnClick && secondaryButtonText && (
        <SecondaryButton
          onClick={secondaryButtonOnClick}
          text={secondaryButtonText}
          data-testid={secondaryTestId}
        />
      )}
    </div>
  );
}